import Context from "shared/util/Context";
import Analytics from "./util/Analytics";
import UrlHelpers from "shared/util/UrlHelpers";
import { IMPORTANCES } from "apps/questions/util/constants";
import isApp from "shared/util/isApp";
import { sourceFromCF } from "analytics/util/source";
import { QUESTIONS_TAB_SOURCES, getQuestionsTabSource } from "analytics/questions_tab";

import {
	SUBMIT_ANSWER_SUCCESS,
	SUBMIT_BINARY_ANSWER_SUCCESS,
	SKIP_ANSWER_SUCCESS,
} from "ducks/questions";

export const sendQuestionAnswerEvent = (question, _params = {}) => {
	const params = { ..._params };
	const pathname = window?.location?.pathname || "";
	const searchname = window?.location?.search || "";

	let source = "public profile";
	let selfViewCriteria;
	const cfSource = sourceFromCF();
	const discoveryOrQuestionsTabSource = getQuestionsTabSource();

	if (isApp()) {
		selfViewCriteria = !searchname.includes("targetid") && !searchname.includes("tuid");
	} else {
		selfViewCriteria = Context.get("username") && pathname.includes(Context.get("username"));
	}

	if (QUESTIONS_TAB_SOURCES[cfSource]) {
		source = cfSource;
	} else if (discoveryOrQuestionsTabSource) {
		source = discoveryOrQuestionsTabSource;
	} else if (selfViewCriteria) {
		source = "self profile";
	} else if (pathname.includes("home")) {
		source = "discovery";
	}

	if (!params.payload) {
		params.payload = {};
	}

	// non-binary questions have id, binary questions have qid
	const questionId = question?.id || question?.qid;

	const data = {
		"question id": questionId,
		"answered publicly": !question.isPrivate,
		reanswer: question?.wasAnswered,
		skipped: params.isSkip || false,
		source,
		"drilldown filter name": params.payload.profileQuestionsFilterName ||
			UrlHelpers.getParam("filter_name"),
		"drilldown filter id": params.payload.profileQuestionsFilterId ||
			UrlHelpers.getParam("filter_id"),
	};

	let importance = IMPORTANCES.SOMEWHAT;

	if (question.importance === IMPORTANCES.VERY) {
		importance = "high";
	} else if (question.importance === IMPORTANCES.SOMEWHAT) {
		importance = "medium";
	} else if (question.importance === IMPORTANCES.LITTLE) {
		importance = "low";
	}

	if (importance && !params.isSkip) {
		data.importance = importance;
	}

	Analytics.logUIEvent(Analytics.eventNames.questionsSubmitted, { data });
};

export default function onboarding(state, action) {
	switch (action.type) {
		case SUBMIT_ANSWER_SUCCESS: {
			sendQuestionAnswerEvent(state.question, { payload: action.payload });

			return;
		}

		case SUBMIT_BINARY_ANSWER_SUCCESS: {
			sendQuestionAnswerEvent(state.question, { payload: action.payload });

			return;
		}

		case SKIP_ANSWER_SUCCESS: {
			sendQuestionAnswerEvent(state.question, { isSkip: true });

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/questions.js